import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RewardDialog from ".";

// Inventory can open a leftover key with #wheel-key=<keyId> without adding a
// second implementation of the wheel or putting player tokens in the URL.
// #quests opens the same Events dialog on its Quests tab; this route is the
// only owner of that hash.
export default function RewardDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const keyMatch = /^#wheel-key=([1-9]\d*)$/.exec(location.hash);
  const historicalKeyId = keyMatch ? Number(keyMatch[1]) : undefined;
  const quests = location.hash === "#quests";
  const open = location.hash === "#events" || location.hash === "#wheel" || quests || Boolean(historicalKeyId);
  // Tab switches replace the entry, so Back still closes the dialog.
  const setHash = (hash: string) => navigate({ pathname: location.pathname, search: location.search, hash }, { replace: true });
  return <RewardDialog open={open} historicalKeyId={historicalKeyId} tab={quests ? "quests" : "wheel"}
    onTabChange={tab => setHash(tab === "quests" ? "#quests" : "#events")}
    onClose={() => setHash("")} />;
}
